<!-- Toggle Switch to Activate/Deactivate the Date Filter -->
<label for="filterToggle" class="filter-toggle-label">Activate Date Range Filter For Leads :</label>
<input 
  type="checkbox" 
  id="filterToggle" 
  class="filter-toggle-input"
  [(ngModel)]="filterDateActive"
  (change)="toggleFilter()"
>

<!-- Date Range Slider (only shown when filter is active) -->
<div *ngIf="filterDateActive" class="date-range-slider-container">
  <label for="daysAgo" class="date-range-label">Select Date Range:</label>
  
  <input 
    type="range" 
    id="daysAgo" 
    class="date-range-slider"
    min="0" 
    max="7" 
    step="1" 
    [(ngModel)]="daysAgo"
    (input)="updateRange()"
  >

  <p class="date-range-text">Showing Leads From <strong>{{displayDateRange }}</strong></p>

 <!-- Apply Button (only visible when the filter is active) -->
<button 
class="apply-button" 
[class.applied]="isApplied"
(click)="submitRange()"
>
{{ isApplied ? 'Applied' : 'Apply' }}
</button>
<div *ngIf="agentStatus" class="agent-status">
  <p><strong>New Leads:</strong> {{ agentStatus.newLeads }}</p>
  <p><strong>No Answer Leads:</strong> {{ agentStatus.noAnswerLeads }}</p>
  <p><strong>Scheduled Leads:</strong> {{ agentStatus.scheduledLeads }}</p>
</div>
</div>



<!-- Wrapper for dropdowns -->
<div class="dropdown-container">
  <!-- Country selection dropdown -->
  <div class="country-selection">
    <label for="country-select">Select Country:</label>
    <div class="dropdown">
      <button class="dropdown-button" (click)="toggleDropdown('country')">
        <span class="selected-countries">{{ selectedCountries.length > 0 ? selectedCountries.join(', ') : 'Select Country' }}</span>
      </button>
      <div class="dropdown-content" *ngIf="dropdownOpen">
        <div *ngFor="let country of countries">
          <label>
            <input
              type="checkbox"
              [checked]="selectedCountries.includes(country)"
              (change)="onCountryToggle(country, $event.target.checked)"
            />
            {{ country }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Preferred Status selection dropdown -->
  <!-- <div class="status-selection">
    <label for="status-select">Prioritized Status: </label>
    <div class="dropdown">
      <button class="dropdown-button-status" (click)="toggleDropdown('status')">
        <span class="selected-statuses">
          {{ selectedStatuses.length > 0 ? selectedStatuses.join(', ') : 'Select Status' }}
        </span>
      </button>
      <div class="dropdown-content-status" *ngIf="dropdownOpenStatus">
        <div *ngFor="let status of statuses">
          <label>
            <input
              type="checkbox"
              [checked]="selectedStatuses.includes(status)"
              (change)="onStatusToggle(status, $event.target.checked)"
            />
            {{ status }}
          </label>
        </div>
      </div>
    </div>
  </div> -->
  <div class="status-selection">
    <label for="status-select">Prioritized Status: </label>
    <div class="dropdown">
      <button class="dropdown-button-status" (click)="toggleDropdown('status')">
        <span class="selected-statuses">
          {{ selectedStatuses.length > 0 ? selectedStatuses[0] : 'Select Status' }}
        </span>
      </button>
      <div class="dropdown-content-status" *ngIf="dropdownOpenStatus">
        <div *ngFor="let status of statuses">
          <label>
            <input
              type="radio"
              name="status"
              [value]="status"
              [checked]="selectedStatuses.includes(status)"
              (change)="onStatusToggle(status, $event.target.checked)"
            />
            {{ status }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <!-- New Company selection dropdown -->
  <!-- <div class="company-selection">
    <label for="company-search">Specific Company:</label>
    <div class="dropdown">
      <input
        type="text"
        id="company-search"
        [(ngModel)]="searchQuery"
        (input)="onSearch()"
        (ngModelChange)="onSearch()"
        placeholder="Pick Your Company..."
        (click)="dropdownOpenCompany = true"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false" />
      <div class="dropdown-content" *ngIf="dropdownOpenCompany">
        <div *ngFor="let company of filteredCompanies" (click)="selectCompany(company)">
          {{ company.name }}
        </div>
      </div>
    </div>
  </div> -->
  <!-- New Company selection dropdown -->
<!-- New Company selection dropdown -->
<!-- <div class="company-selection">
  <label for="company-search">Specific Company:</label>
  <div class="dropdown">
    <input
      type="text"
      id="company-search"
      [(ngModel)]="searchQuery"
      (input)="onSearch()"
      (ngModelChange)="onSearch()"
      placeholder="Pick Your Company..."
      (click)="dropdownOpenCompany = true"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false" />
    <div class="dropdown-content" *ngIf="dropdownOpenCompany">
      <div *ngFor="let company of filteredCompanies" (click)="selectCompany(company)">
        {{ company.name }}
      </div>
    </div>
  </div>
  <div class="selected-companies">
    <label>Selected Companies:</label>
    <div *ngFor="let company of selectedCompanies">
      {{ company.name }} <button (click)="removeCompany(company)">Remove</button>
    </div>
  </div>
</div> -->
<div class="company-selection">
  <label for="company-search">Specific Company:</label>
  <div class="dropdown">
    <input
      type="text"
      id="company-search"
      [(ngModel)]="searchQuery"
      (input)="onSearch()"
      (ngModelChange)="onSearch()"
      placeholder="Pick Your Company..."
      (click)="dropdownOpenCompany = true"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false" />
    <div class="dropdown-content" *ngIf="dropdownOpenCompany">
      <div *ngFor="let company of filteredCompanies" (click)="selectCompany(company)">
        {{ company.name }}
      </div>
    </div>
  </div>

  <!-- Display selected companies as tags/buttons -->
  <div class="selected-companies">
    <label>Selected Companies:</label>
    <div *ngFor="let company of selectedCompanies" class="selected-company">
      <span>{{ company.name }}</span>
      <button (click)="removeCompany(company)" class="remove-button">X</button>
    </div>
  </div>
</div>


</div>
<div *ngIf="isLoadingNextLead" class="loader-overlay">
  <div class="spinner"></div>
  <p class="loader-text">Lead Loading</p>
</div>
<button class="next-button" (click)="navigateToNextLead()">
  Next Lead
</button>
<!-- <p class="main-content-agent">NO CONTENT IS AVAILABLE HERE</p>

<p *ngIf="leads.length === 0">No leads found for the given phone number.</p> -->

<!-- Message displayed when there's no search or result -->
<p class="main-content-agent" *ngIf="!leads">NO CONTENT IS AVAILABLE HERE</p>

<!-- Show error message if no lead is found -->
<p *ngIf="errorMessage && leads.length === 0" class="error-message">{{ errorMessage }}</p>

<!-- Display leads in a modern, clean row layout -->
<div *ngIf="leads && leads.length > 0">
  <div *ngFor="let lead of leads" class="lead-row">
    <!-- Lead Details (Info + Actions) -->
    <div class="lead-details">
      <!-- Lead Information -->
      <div class="lead-info">
        <span><strong>Name:</strong> {{ lead.name }}</span>
        <span><strong>Phone:</strong> {{ lead.primaryPhoneNumber }}</span>
        <span><strong>FBL-Ref#:</strong> {{ lead.fbLeadReference }}</span>
        <span><strong>Ref#:</strong> {{ lead.referenceNumber }}</span>
        <span><strong>Status:</strong> {{ lead.status }}</span>
        <span><strong>Country:</strong> {{ lead.country }}</span>
        <span><strong>Province:</strong> {{ lead.province || 'N/A' }}</span>
        <span><strong>Shop Name:</strong> {{ lead.shopName || 'N/A' }}</span>
        <span><strong>Creation-Date:</strong> {{ lead.creationDate || 'N/A' }}</span>
      </div>

      <!-- Lead Actions -->
      <div class="lead-actions">
        <button class="open-button" (click)="openLeadDetails(lead.fbLeadReference)">Open</button>
        <button class="history-button" (click)="toggleHistory(lead.id, lead.fbLeadReference)">
          {{ expandedLeadId === lead.id ? 'Hide History' : 'Show History' }}
        </button>
      </div>
    </div>

    <!-- Expandable Section -->
    <div *ngIf="expandedLeadId === lead.id" class="expanded-section">
      <div class="expanded-content">
        <ul *ngIf="leadHistories[lead.id]?.length > 0">
          <li *ngFor="let history of leadHistories[lead.id]">
            <span><strong>Status:</strong> {{ history.callCenterLeadStatus }}</span>
            <span><strong>Status Updated At:</strong>{{ history.createdAt ? (history.createdAt | date: 'yyyy-MM-dd HH:mm:ss') : 'N/A' }}</span>
          </li>
        </ul>
        <div *ngIf="leadHistories[lead.id] === null">
          <em>No history found for this lead.</em>
        </div>
        <div *ngIf="leadHistories[lead.id]?.length === 0">
          <em>No history entries available.</em>
        </div>
        <div *ngIf="leadHistories[lead.id] === undefined">
          <em>Loading history...</em>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Display a message if no leads are found -->
<!-- <p *ngIf="leads.length === 0 && !errorMessage">No leads found for the given phone number.</p> -->


